import alert from './alert';

export default alert;
export { initAlert, DEFAULT_ERROR_MESSAGE } from './alert';
